import type { PackageDefinitionTransform, PackageJson } from '@ms-cloudpack/common-types';
import { getBuiltInSettings } from './getBuiltInSettings.js';

/**
 * Applies package.json modifications from Cloudpack's `builtInSettings` for a package, if relevant.
 * Does nothing if no matches are found.
 */
export function createBuiltInSettingsTransform(): PackageDefinitionTransform {
  return ({ definition }) => _applyBuiltInSettings(definition);
}

export function _applyBuiltInSettings(definition: PackageJson): PackageJson | undefined {
  const builtInSettings = getBuiltInSettings(definition);
  if (builtInSettings?.packageJson) {
    // For now, just overwrite any top-level keys. This could be modified later if needed
    // (though we always want to overwrite exports).
    return Object.assign(definition, builtInSettings.packageJson);
  }
  return undefined;
}
